module.exports = "/lucky-balls/img/jackpot/001.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/jackpot/001.png
// module id = 1101
// module chunks = 0